import TelephoneImage from '../../../../../assets/image/Designs/contactdesign.png'
import InfoExpand from '../../../../../assets/svg/DesignIcons/infoexpandicon'

const ClosedInfoView = (props) => {
    const {Expand} = props
    return (
        <>
            <div className='contact-page-view-container-telephone-main-container' data-aos="fade-down">
                <img src={TelephoneImage} alt='' />
            </div>
            <div className='contact-page-view-container-comapny-profile-container' data-aos="fade-left">
                <div className='contact-page-view-container-comapny-profile-container-top'></div>
                <div className='contact-page-view-container-comapny-profile-container-middle'>
                    <InfoExpand onClick={Expand} />
                </div>
                <div className='contact-page-view-container-comapny-profile-container-bottom'></div>
            </div>
        </>
    )
}

export default ClosedInfoView;
